<span class="carousel-item"
	[@translateCarouselItem]="{
		value: position,
		params: { animationDuration: animationDuration }
	}"
>
	<ng-content></ng-content>
</span>
